// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/about.scss';

// Packages
import Vue from 'vue';
import Typed from 'typed.js';
import ScrollBooster from 'scrollbooster';
import noUiSlider from 'nouislider';
import scrollToElement from 'scroll-to-element';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';
import initRequestForm from '~scripts/blocks/request-form';
import '~scripts/blocks/events/forum-2023/forum-results';
import '~scripts/blocks/events/forum-2023/modal-video';

// Components
import '~scripts/components/modals';

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { scrollAnimationProgress } from '~scripts/core/animations';

// Swiper
import Swiper from 'swiper';
import { EffectFade, Navigation as SwiperNavigation, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([EffectFade, SwiperNavigation, SwiperPagination]);

// Media
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// CLIENTS
//
new Vue({
  el: '#VClientsLogotypes',
  name: 'VClientsLogotypes',
  components: {
    ClientsLogotypes,
  },
});

// typed animation
const typeSpeedAnimation = 80;
const backSpeedAnimation = typeSpeedAnimation / 2;
const replaceText = 'Ведущая';

const options = {
  strings: ['Любимая', 'Мощная', 'Заботливая', 'Передовая', 'Уютная', replaceText],
  typeSpeed: typeSpeedAnimation,
  backDelay: 2500,
  backSpeed: backSpeedAnimation,
  loop: true,
  attr: null,
};

new Typed('.js-word-animation', {
  strings: [replaceText, ''],
  backSpeed: options.backSpeed,
  backDelay: options.backDelay,
  attr: options.attr,
  startDelay: 2500,
  onBegin: function () {
    setTimeout(function () {
      document.querySelector('.typed-cursor').classList.add('typed-cursor--blink');
    }, 10);
  },
  onComplete: function (t) {
    t.destroy();
    document.querySelector('.js-word-animation').textContent = '';
    new Typed('.js-word-animation', options);
  },
});

// circle animation
const advantage = document.querySelector('.js-advantage');

const handleAdvantageAnimation = () => {
  return scrollAnimationProgress(advantage, {
    getStart(el) {
      const rect = el.getBoundingClientRect();
      return rect.top + window.scrollY - window.innerHeight / 2;
    },
    getEnd(el, start) {
      const height = el.offsetHeight;
      return start + window.innerHeight - 400;
    },
  });
};

handleAdvantageAnimation();
mediaSm.addEventListener('change', handleAdvantageAnimation);

// mission animation
const missionSection = document.querySelector('.js-mission');

scrollAnimationProgress(missionSection, {
  getStart(el) {
    const rect = el.getBoundingClientRect();
    if (mediaSm.matches) {
      return rect.top + window.scrollY - window.innerHeight / 2;
    }
    return rect.top + window.scrollY - window.innerHeight / 8;
  },
  getEnd(el, start) {
    const height = el.offsetHeight;
    if (mediaSm.matches) {
      return start + height / 2 - 72;
    }
    return start + height / 6 - 72;
  },
});

// huntflow helps items animation
import huntflowHelpsItemsInit from '~scripts/blocks/huntflow-helps-items';

huntflowHelpsItemsInit();

// leaders animation
let stopLeaderItemAnimation = [];

const handleLeaderItemAnimation = () => {
  const leaderItem = document.querySelectorAll('.js-leaders-item');

  if (mediaSm.matches) {
    stopLeaderItemAnimation.forEach((stop) => stop());
  } else {
    stopLeaderItemAnimation = Array.from(leaderItem, (item) => {
      return scrollAnimationProgress(item, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          const height = el.offsetHeight;
          return start + height;
        },
      });
    });
  }
};

handleLeaderItemAnimation();
mediaSm.addEventListener('change', handleLeaderItemAnimation);

// charity slider

const charitySliderOptionsSm = {
  allowTouchMove: true,
  effect: 'slide',
  loop: false,
  navigation: false,
  noSwiping: false,
  slidesPerView: 'auto',
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  spaceBetween: 12,
  pagination: false,
};
const charitySliderOptionsMd = {
  allowTouchMove: false,
  effect: 'fade',
  loop: true,
  navigation: {
    nextEl: '#charitySlider .swiper-button-next',
    prevEl: '#charitySlider .swiper-button-prev',
  },
  pagination: {
    el: '#charitySlider .swiper-pagination',
    clickable: true,
  },
  noSwiping: true,
  slidesPerView: 1,
  spaceBetween: 0,
};

let charitySlider = null;

const handlecharitySliderInit = () => {
  if (charitySlider) {
    charitySlider.destroy();
  }

  const options = mediaSm.matches ? charitySliderOptionsSm : charitySliderOptionsMd;

  charitySlider = new Swiper('#charitySlider', options);
};

handlecharitySliderInit();
mediaSm.addEventListener('change', handlecharitySliderInit);

// timelineSlider

const leadersContainer = document.getElementById('leadersContainer');
const rangeSlider = document.getElementById('timeline-range');
const sliderLeftOffset = (window.innerWidth - leadersContainer.offsetWidth) / 2;
const timelineContainer = document.getElementById('timelineContainer');
const timeLineInner = document.getElementById('timelineInner');

timelineContainer.style.padding = `0 0 0 ${sliderLeftOffset}px`;

window.addEventListener('resize', () => {
  timelineContainer.style.padding = `0 0 0 ${(window.innerWidth - leadersContainer.offsetWidth) / 2}px`;

  if (!mediaSm.matches) {
    let rangeSliderMaxValue =
      timeLineInner.offsetWidth - window.innerWidth + (window.innerWidth - leadersContainer.offsetWidth) / 2;
    rangeSlider.noUiSlider.updateOptions({
      range: {
        min: 1,
        max: rangeSliderMaxValue,
      },
    });
  }
});

const handleTimelineSlider = () => {
  let isRangeDraged = false;

  if (!mediaSm.matches) {
    let rangeSliderMaxValue =
      timeLineInner.offsetWidth - window.innerWidth + (window.innerWidth - leadersContainer.offsetWidth) / 2 + 24;

    let timelineRange = noUiSlider.create(rangeSlider, {
      start: [1],
      range: {
        min: 1,
        max: rangeSliderMaxValue,
      },
    });

    timelineRange.on('slide', function (values) {
      timelineSlider.scrollTo({ x: values, y: 0 });
    });

    let rangeOrigin = document.querySelector('.noUi-origin');

    timelineRange.on('start', () => {
      isRangeDraged = true;
      rangeOrigin.classList.add('noUi-origin--active');
    });

    timelineRange.on('end', () => {
      rangeOrigin.classList.remove('noUi-origin--active');
    });

    let timelineRangeThumb = document.querySelector('.noUi-touch-area');

    const timelineSlider = new ScrollBooster({
      viewport: document.querySelector('#timelineSlider'),
      content: document.querySelector('#timelineInner'),
      scrollMode: 'transform',
      direction: 'horizontal',
      emulateScroll: true,
      pointerDownPreventDefault: false,
      lockScrollOnDragDirection: 'horizontal',
      preventDefaultOnEmulateScroll: 'horizontal',
      bounce: true,
      friction: 0.07,
      onUpdate: (state) => {
        const sliderSection = document.querySelectorAll('.timeline-slider__section');

        sliderSection.forEach((item) => {
          const rect = item.getBoundingClientRect();
          let windowWidth = window.innerWidth;

          if (rect.left - windowWidth / 2 < 0) {
            timelineRangeThumb.innerHTML = item.dataset.year;
          }
        });

        if (!state.isMoving) {
          isRangeDraged = false;
        }

        if (!isRangeDraged) {
          timelineRange.set(state.position.x);
        }
      },
    });
  } else {
    if (rangeSlider.classList.contains('noUi-target')) {
      rangeSlider.noUiSlider.destroy();
    }
    const timelineSlider = new ScrollBooster({
      viewport: document.getElementById('timelineSlider'),
      content: document.getElementById('timelineInner'),
      scrollMode: 'transform',
      pointerMode: 'touch',
      direction: 'horizontal',
      bounce: true,
      friction: 0.07,
      pointerDownPreventDefault: false,
      lockScrollOnDragDirection: 'horizontal',
    });
  }
};

handleTimelineSlider();
mediaSm.addEventListener('change', handleTimelineSlider);

let timelineSection = document.getElementById('timeline');

if (window.location.hash == '#history') {
  window.scrollTo(0, 0);
  scrollToElement(timelineSection, {
    align: 'top',
    offset: -65,
    ease: 'linear',
    duration: 900,
  }).on('end', () => {
    scrollToElement(timelineSection, {
      align: 'top',
      offset: -65,
      ease: 'linear',
      duration: 200,
    });
  });
}

scrollAnimationProgress(timelineSection, {
  getStart(el) {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY - rect.height / 2;
  },
  getEnd(el, start) {
    const height = el.offsetHeight;
    return start + height * 0.725;
  },
  onProgress: (progress) => {
    if (progress > 0.5) {
      let timelineSlider = document.getElementById('timelineSlider');
      timelineSlider.classList.add('timeline-slider--animation');
    }
  },
});
